// ===== 価格スライダー =====
(function(){

  function getFacetForm(){
    const mobileForm = document.querySelector("#FacetFiltersFormMobile");
    const desktopForm = document.querySelector("#FacetFiltersForm");

    if (window.innerWidth < 990 && mobileForm) {
      return mobileForm;
    }

    return desktopForm || mobileForm;
  }

  function initPriceSlider(){

    const sliders = document.querySelectorAll(".price-range-slider");
    if(!sliders.length) return;

    sliders.forEach(slider => {

      if(slider.dataset.initialized) return;
      slider.dataset.initialized = "true";

      const minSlider = slider.querySelector(".slider-min");
      const maxSlider = slider.querySelector(".slider-max");
      const clearBtn = slider.querySelector(".price-clear");

      const minDisplay = slider.querySelector(".price-min");
      const maxDisplay = slider.querySelector(".price-max");
      const track = slider.querySelector(".slider-track");

      const minParam = minSlider.name;
      const maxParam = maxSlider.name;

      const params = new URLSearchParams(location.search);

      // URLパラメータ優先
      const urlMin = params.get(minParam);
const urlMax = params.get(maxParam);

let minVal = urlMin !== null
  ? parseInt(urlMin,10)
  : (minSlider.value ? parseInt(minSlider.value,10) : 0);

let maxVal = urlMax !== null
  ? parseInt(urlMax,10)
  : (maxSlider.value ? parseInt(maxSlider.value,10) : parseInt(maxSlider.max,10));

if(isNaN(minVal)) minVal = 0;
if(isNaN(maxVal)) maxVal = parseInt(maxSlider.max,10);

minSlider.value = minVal;
maxSlider.value = maxVal;

      minSlider.value = minVal;
      maxSlider.value = maxVal;

      function update(){

        let min = parseInt(minSlider.value,10) || 0;
        let max = parseInt(maxSlider.value,10) || parseInt(maxSlider.max,10);

        if(min > max){
          min = max;
          minSlider.value = min;
        }

        minDisplay.textContent = "¥" + min.toLocaleString();
        maxDisplay.textContent = "¥" + max.toLocaleString();

        const sliderMax = parseInt(maxSlider.max,10) || 1;

        const percentMin = (min / sliderMax) * 100;
        const percentMax = (max / sliderMax) * 100;

        track.style.background =
          `linear-gradient(to right,
            #E2E8F0 ${percentMin}%,
            #FB6E00 ${percentMin}%,
            #FB6E00 ${percentMax}%,
            #E2E8F0 ${percentMax}%)`;
      }

      function applyFilter(){

  const min = minSlider.value;
  const max = maxSlider.value;

  const form = getFacetForm();
  if(!form) return;

  /* すべての price input を更新（PC + SP） */
  const minInputs = document.querySelectorAll('[name="filter.v.price.gte"]');
  const maxInputs = document.querySelectorAll('[name="filter.v.price.lte"]');

  minInputs.forEach(input=>{
    input.value = min;
  });

  maxInputs.forEach(input=>{
    input.value = max;
  });

  /* Shopify facets 更新 */
  setTimeout(()=>{
    form.dispatchEvent(new Event("input",{bubbles:true}));
  },0);

}

      function applyFilterSafe(){
        applyFilter();
      }

      // スライダー操作
      minSlider.addEventListener("input", e=>{
        e.stopPropagation();
        update();
      });

      maxSlider.addEventListener("input", e=>{
        e.stopPropagation();
        update();
      });

      // 確定時のみフィルター
      minSlider.addEventListener("mouseup", applyFilterSafe);
      minSlider.addEventListener("touchend", applyFilterSafe);

      maxSlider.addEventListener("mouseup", applyFilterSafe);
      maxSlider.addEventListener("touchend", applyFilterSafe);

      // クリアボタン
      if(clearBtn){
        clearBtn.addEventListener("click", function(){

          minSlider.value = minSlider.min;
          maxSlider.value = maxSlider.max;

          update();

          const url = new URL(location.href);
          url.searchParams.delete(minParam);
          url.searchParams.delete(maxParam);

          location.href = url.toString();
        });
      }

      update();

    });

  }

  document.addEventListener("DOMContentLoaded", initPriceSlider);
  document.addEventListener("shopify:section:load", initPriceSlider);

  const facetWrapper = document.querySelector(".facets-wrapper");

  if (facetWrapper) {

    const observer = new MutationObserver(function() {
      initPriceSlider();
    });

    observer.observe(facetWrapper, {
      childList: true,
      subtree: true
    });

  }

  // モバイルフィルター開閉
  document.addEventListener("click", function(e){

    if(!e.target.closest(".mobile-facets__summary")) return;

    setTimeout(initPriceSlider,100);

  });

  // フィルター削除時
  document.addEventListener("click", function(e){

    if(!e.target.closest('.price-facet-remove, .facets__reset, .active-facets__button-remove')) return;

    const sliders = document.querySelectorAll(".price-range-slider");

    sliders.forEach(slider => {

      const minSlider = slider.querySelector(".slider-min");
      const maxSlider = slider.querySelector(".slider-max");

      minSlider.value = minSlider.min;
      maxSlider.value = maxSlider.max;

      const event = new Event("input",{bubbles:true});
      minSlider.dispatchEvent(event);

    });

  });

  document.addEventListener("facet:updated", function(){
  initPriceSlider();
});

})();